import React from "react";
import "./utils.css";


export default function ReusableTable({ columns, data, clickView }) {

  const clickAction = (row) => {
    if (clickView){
      clickView(row);
    }
  }

  return (
    <div className="table-container">
      <table className="reusable-table">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row, rowIndex) => (
            <tr key={rowIndex}>
                <td>
                  {rowIndex + 1}
                </td>
                <td style={{textTransform: "capitalize"}}>
                  {row?.name}
                </td>
                <td>
                  {row?.propertyType}
                </td>
                <td>
                  {row?.estate?.name}
                </td>
                <td>
                  {row?.createdAt?.split("T")[0]}
                </td>
                <td>
                  <p className={row?.isVerified ? "available" : 'unavailable'}>{row?.isVerified ? "Available" : "Unavailable"}</p>
                </td>
                <td onClick={() => clickAction(row)}>
                  <p className="table_action">View</p>
                </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
